module.exports = __webpack_public_path__ + "img/horizontal_6_5_6005.f23a9c8e.png";